import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    addressDetail: LocalStorageFunc.getAddressDetail(),
    addContactDetailsIsOpen: false
  },
  getters: {
    getShowThankYouModal(state) {
      return state.showThankYou;
    },
  },
  mutations: {
    saveAddressDetail(state, { fieldName, fieldValue }) {
      const addressDetail = { ...state.addressDetail, [fieldName]: fieldValue };
      state.addressDetail = addressDetail;
      localStorage.addressDetail = JSON.stringify(addressDetail);
    },
    updateAddContactDetailsModal(state, payload){
        state.addContactDetailsIsOpen = payload
        payload && document.body.classList.add("body-stop-scroll-mobile");
    },
  },
  actions: {},
};
